import { render, staticRenderFns } from "./SectionHeader.vue?vue&type=template&id=897649ce&scoped=true&"
import script from "./SectionHeader.vue?vue&type=script&lang=js&"
export * from "./SectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./SectionHeader.vue?vue&type=style&index=0&id=897649ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897649ce",
  null
  
)

export default component.exports